import React, { useContext } from 'react';
import { Link } from 'gatsby';
// import Loadable from '@loadable/component';

import { AnalyticsContext } from '../../analytics/AnalyticsContext';

import CharterLogo from '../../svgs/charterLogo.svg';
import SpectrumLogo from '../../svgs/spectrum_logo.svg';

import SocialMediaButtons from '../SocialMediaButtons/SocialMediaButtons';
import { useVisitId } from '../../hooks/useVisitId';
import useContextToken from '../../hooks/useContextToken';
import { getBuyflowLink } from '../../utils/helpers';

// import { isMobile } from '../../utils/isMobile';

import './Footer.scss';

// const SOFeedbackForm = Loadable(() =>
//   import('../SOFeedbackForm/SOFeedbackForm')
// );

// const StickyFeedbackButton = Loadable(() =>
//   import('../StickyFeedbackButton/StickyFeedbackButton')
// );

// TEALIUM
import initTealiumTracker from 'tealium-tracker';
let tealiumTrackEvent;
if (typeof window !== 'undefined') {
  const { trackEvent } = initTealiumTracker({ debugMode: true });
  tealiumTrackEvent = trackEvent;
}

const sections = {
  'Site Navigation': {
    quantumEventCase: 'SpectrumOnDemand_selectAction_footerSiteNavigation',

    links: [
      { title: 'Home', url: '/', internal: true, quantumName: 'home' },
      {
        title: 'Movies',
        url: '/movies/',
        internal: true,
        quantumName: 'movies',
      },
      {
        title: 'TV Shows',
        url: '/tv/',
        internal: true,
        quantumName: 'tvShows',
      },
      // {
      //   title: 'Events',
      //   url: '/events/',
      //   internal: true,
      //   quantumName: 'events',
      // },
      {
        title: 'Networks',
        url: '/networks/',
        internal: true,
        quantumName: 'networks',
      },
      {
        title: 'Trailers',
        url: '/trailers/',
        internal: true,
        quantumName: 'trailers',
      },
      {
        title: 'TV Apps',
        url: '/tv-apps/',
        internal: true,
        quantumName: 'tv-apps',
      },
      {
        title: 'Access',
        url: '/access/',
        internal: true,
        quantumName: 'access',
      },
    ],
  },
  'Spectrum Customers': {
    quantumEventCase: 'SpectrumOnDemand_selectAction_footerSpectrumCustomers',
    links: [
      {
        title: 'Manage Account',
        url: 'https://www.spectrum.net',
        quantumName: 'manageAccount',
      },
      {
        title: 'Get Support',
        url: 'https://www.spectrum.net/support',
        quantumName: 'getSupport',
      },
      {
        title: 'Watch TV',
        url: 'https://watch.spectrum.net/ondemand',
        quantumName: 'watchTv',
      },
    ],
  },
  'Privacy & Terms': {
    quantumEventCase: 'SpectrumOnDemand_selectAction_footerPrivacyTerms',
    links: [
      {
        title: 'Your Privacy Rights',
        url: 'https://www.spectrum.com/policies/your-privacy-rights',
        quantumName: 'yourPrivacyRights',
      },
      {
        title: 'California Privacy Rights',
        url: 'https://www.spectrum.com/policies/california',
        quantumName: 'californiaPrivacyRights',
      },
      {
        title:
          'Do Not Sell or Share My Personal Information/Opt-Out of Targeted Advertising',
        url: 'https://www.spectrum.com/policies/your-privacy-rights-opt-out',
        quantumName: 'californiaDoNotSellMyInformation',
      },
      {
        title:
          'California Consumer Limit the Use of My Sensitive Personal Information',
        url: 'https://www.spectrum.com/policies/your-privacy-rights-opt-out',
        quantumName: 'californiaLimitTheUseOfMyInformation',
      },
      {
        title: 'Policies',
        url: 'https://www.spectrum.com/policies/terms-of-service',
        quantumName: 'policies',
      },
    ],
  },

  Information: {
    quantumEventCase: 'SpectrumOnDemand_selectAction_footerInformation',
    links: [
      {
        title: 'Find a Spectrum Store',
        url: 'https://www.spectrum.com/stores.html',
        quantumName: 'spectrumStore',
      },
      {
        title: 'Contact Us',
        url: 'https://www.spectrum.com/contact-us?cmp=sod_contactus_bottomnav',
        quantumName: 'contactUs',
      },
      {
        title: 'Shop Spectrum TV Plans',
        url: 'https://www.spectrum.com/cable-tv/plans?cmp=sod_tvplans_bottomnav',
        quantumName: 'tvPlans',
      },
    ],
  },
};

const socialLinks = [
  { name: 'Instagram', url: 'https://www.instagram.com/getspectrum' },
  { name: 'Facebook', url: 'https://www.facebook.com/Spectrum' },
  { name: 'Twitter', url: 'https://twitter.com/getspectrum' },
  { name: 'Youtube', url: 'https://www.youtube.com/c/getspectrum' },
];

const Footer = () => {
  const { analytics } = useContext(AnalyticsContext);
  const visitId = useVisitId();
  const { contextToken } = useContextToken();

  const buyflowLinkStores = getBuyflowLink(
    'https://www.spectrum.com/stores?cmp=sspp_sod_gm_footer_stores_unauth_050523',
    'https://www.spectrum.com/stores?cmp=sspp_sod_gm_footer_stores_auth_050523'
  );
  const buyflowLinkPlans = getBuyflowLink(
    'https://www.spectrum.com/cable-tv/plans?cmp=sspp_sod_gm_footer_shop_unauth_050523',
    'https://www.spectrum.net/change?cid=sspp_sod_gm_footer_shop_auth_050523'
  );
  // const [showFeedback, setShowFeedback] = useState(false);

  const quantumTrack = (eventCase, currPageElemStdName) => {
    analytics.track(eventCase, {
      currPageElemStdName,
    });
  };

  // Checks the URL for existing parameters and adds the visitId
  const checkUrl = (url) => {
    if (url === 'https://www.spectrum.com/stores.html') {
      url = buyflowLinkStores;
    }

    if (
      url ===
      'https://www.spectrum.com/cable-tv/plans?cmp=sod_tvplans_bottomnav'
    ) {
      url = buyflowLinkPlans;
    }

    if (url.includes('spectrum.com') || url.includes('spectrum.net')) {
      const currentUrl = new URL(url);
      const params = new URLSearchParams(currentUrl.search);

      params.set('visitId', visitId);

      return `${currentUrl.origin}${currentUrl.pathname}?${params.toString()}${contextToken}`;
    }

    return url;
  };

  const displayCategories = Object.keys(sections).map((section) => (
    <section className="footer__category" key={section}>
      <h3 className="footer__category-title">{section}</h3>
      <ul>
        {sections[section].links.map((link) => {
          const { internal, title, url, quantumName } = link;
          if (internal) {
            return (
              <li key={title} className="footer__category-list-item">
                <Link
                  className="footer__category-link"
                  to={url}
                  activeClassName="footer__category-link--active"
                  onClick={() => {
                    quantumTrack(
                      sections[section].quantumEventCase,
                      quantumName
                    );
                    tealiumTrackEvent({
                      linktype: 'footer',
                      linkname: title,
                    });
                  }}
                  data-linktype="footer"
                  data-linkname={title}
                >
                  {link.title}
                </Link>
              </li>
            );
          }

          return (
            <li key={title} className="footer__category-list-item">
              <a
                className="footer__category-link"
                href={checkUrl(url)}
                onClick={() => {
                  tealiumTrackEvent({
                    linktype: 'footer',
                    linkname: title,
                  });
                  quantumTrack(sections[section].quantumEventCase, quantumName);
                }}
                data-linktype="footer"
                data-linkname={title}
              >
                {title}
              </a>
            </li>
          );
        })}
        {/* {category === 'Information' && (
            <button
              className="footer__feedback-link"
              onClick={() => setShowFeedback(true)}
            >
              Give Feedback
            </button>
          )} */}
      </ul>
    </section>
  ));

  return (
    <footer className="footer">
      {/* {showFeedbackButton && !isMobile.any() && (
          <StickyFeedbackButton setShowFeedback={setShowFeedback} />
        )} */}
      <div className="footer__top">
        <div className="footer__top-inner">
          <section className="footer__logo-social">
            <SpectrumLogo aria-label="Spectrum" role="img" focusable="false" />
            <SocialMediaButtons
              links={socialLinks}
              account="Spectrum"
              analytics={analytics}
            />
          </section>
          <section className="footer__categories">{displayCategories}</section>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__bottom-inner">
          <CharterLogo
            aria-label="Charter Communications"
            role="img"
            focusable="false"
          />
          <p className="footer__disclaimer">
            On Demand service available to residential customers only who
            subscribe to Spectrum TV™ in Digital, TV Select or above. On Demand
            programming varies by level of service; pricing, ratings and
            scheduling are subject to change. Trademarks belong to their
            respective owners.
          </p>
          <p className="footer__copyright">
            &copy; {new Date().getFullYear()} Charter Communications
          </p>
        </div>
      </div>
      {/* <SOFeedbackForm
          analytics={analytics}
          showFeedback={showFeedback}
          onHide={() => setShowFeedback(false)}
        /> */}
    </footer>
  );
};

export default Footer;
